import { render, staticRenderFns } from "./pavilion.vue?vue&type=template&id=0e7a14d2&scoped=true"
import script from "./pavilion.vue?vue&type=script&lang=js"
export * from "./pavilion.vue?vue&type=script&lang=js"
import style0 from "./pavilion.vue?vue&type=style&index=0&id=0e7a14d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a14d2",
  null
  
)

export default component.exports